import request from '@/utils/request'
export default {
  /**
   * 创建清台酒水充公单
   * @param data
   * @returns
   */
  createWineConfiscation(data) {
    return request.post('/wine-confiscations', data)
  }
}
